import axios from 'axios';

export const consultarCEP = ({cep}) => {
    return axios.get(`https://viacep.com.br/ws/${cep}/json/`)
    .then(dados => {return dados.data})
    .catch(error => {return error});
}